/* eslint-disable no-case-declarations */
import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import { Grid, Card, Button, Typography } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components'
import moment from 'moment'
import { useSnackbar } from 'notistack'

import BasicTable from '../../../components/BasicTable';
import { FilterSection } from './components';
import BasicDialog from '../../../components/BasicDialog';
import BasicFab from '../../../components/BasicFab';

import ExportCSVButton from '../../../helpers/ExportTableExcel';
import { formattedDateWithMoment } from '../../../helpers/date';
import { db } from '../../../firebase';
import * as actionTypes from '../../../store/actions/actionTypes';
import { setTablePage } from '../../../store/reducers/submissions';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.default
  },
  grid: {
    height: '100%',
    padding: theme.spacing(2),
    justifyContent: 'center',
    alignItems: 'center'
  },
  content: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  contentBody: {
    flexGrow: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  filters: {
    display: 'block',
    marginBottom: theme.spacing(3)
  },
  tableContainer: {
    maxWidth: '100vw',
  },
  table: {
    tableLayout: 'fixed',
    width: '100%',
    overflowX: 'auto',
  },
  exportContainer: {
    padding: '12px',
    marginBottom: '24px',
    display: 'flex',
    justifyContent: 'flex-end'
  },
}));

const SubmissionsTable = styled(BasicTable)`
`;

const ExportCard = styled(Card)`
  ${({theme}) => theme.breakpoints.down('xs')}{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
`;

const SubmissionsList = ({ history }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const userRole = useSelector(state => state.auth.user.roles[0]);
  const userId = useSelector(state => state.auth.userId);
  const { username } = useSelector(state => state.auth.user);
  const [loading, setLoading] = useState(false);
  const filters = useSelector(state => state.filters.filters);
  const filteredSubmissions = useSelector(
    state => state.filters.filteredSubmissions
  );
  const tableHeaders = [
    { label: t('tableHeaders.date'), key: 'date' },
    { label: t('tableHeaders.reference'), key: 'reference' },
    { label: t('tableHeaders.storen'), key: 'storen' },
    { label: t('tableHeaders.store'), key: 'store' },
    { label: t('tableHeaders.partner'), key: 'partner' },
    { label: `${t('tableHeaders.worker')}/${t('tableHeaders.partner')}`, key: 'worker' },
    { label: t('tableHeaders.city'), key: 'city' },
    { label: t('tableHeaders.street'), key: 'street' },
    { label: t('tableHeaders.comments'), key: 'comments' }
  ];

  const [submissions, setSubmissions] = useState([]);
  const [exportSubmissions, setExportSubmissions] = useState([]);
  const [exportSubsWithAssortment, setExportSubsWithAssortment] = useState([]);
  const [selectedSubmissions, setSelectedSubmissions] = useState([]);
  const [references, setReferences] = useState([]);
  const [partners, setPartners] = useState([]);
  const [workers, setWorkers] = useState([]);
  const [storeNumbers, setStoreNumbers] = useState([]);
  const [storeNames, setStoreNames] = useState([]);
  const [classifications, setClassifications] = useState([]);
  const [types, setTypes] = useState([]);
  const [regions, setRegions] = useState([]);
  const [cities, setCities] = useState([]);
  const [streets, setStreets] = useState([]);
  const [areFiltersEstablished, setAreFiltersEstablished] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);

  const [refreshSubs, setRefreshSubs] = useState(0);
  const [refreshFilterSubs, setRefreshFilterSubs] = useState(0);
  const [isShortQuery, setIsShortQuery] = useState(true);

  const hasSelectedItems = selectedSubmissions.length !== 0;

  const exportSubsUtil = submissions => {
    const subArray = [];
    submissions &&
      submissions.forEach(element => {
        if (element.products.length > 0) {
          subArray.push(
            ...element.products.map(prod => {
              return {
                id: element.id,
                Datum: element.date,
                Nalog: element.reference,
                Partner: element.partner,
                Radnik: element.worker,
                // storeNumber: element.storeNumber,
                PM: element.storeNumber + ' - ' + element.storeName,
                Grad: element.city,
                Ulica: element.street,
                //Komentari: element.comments,
                Šifra_artikla: prod.productId,
                Ime_artikla: prod.name,
                Barkod: prod.barcode,
                Pakiranje: prod.package,
                JM: prod.unit,
                Količina: prod.quantity,
                Broj_narudžbe: element.orderNotice,
                Država: element.country
              };
            })
          );
        } else {
          subArray.push({
            id: element.id,
            Datum: element.date,
            Nalog: element.reference,
            Partner: element.partner,
            Radnik: element.worker,
            // storeNumber: element.storeNumber,
            PM: element.storeNumber + ' - ' + element.storeName,
            Grad: element.city,
            Ulica: element.street,
            //Komentari: element.comments,
            Šifra_artikla: '',
            Ime_artikla: '',
            Barkod: '',
            Pakiranje: '',
            JM: '',
            Količina: '',
            Broj_narudžbe: element.orderNotice,
            Država: element.country
          });
        }
      });
    return subArray;
  };

  // reset table page
  useEffect(() => { dispatch(setTablePage({ returns: 0 })) }, [])

  const exportWithAssortmentFortmetter = (submissions = []) => {
    const rows = [];

    submissions.forEach(({assortments: asrts, ...rest}) => {

      const assortments = asrts || []
      
      const exportRow = {
        id: rest.id,
        Datum: rest.date,
        Nalog: rest.reference,
        Partner: rest.partner,
        Radnik: rest.worker,
        PM: rest.storeNumber + ' - ' + rest.storeName,
        Grad: rest.city,
        Ulica: rest.street,
        Broj_narudžbe: rest.orderNotice,
        Država: rest.country,
        Asortiman: '',
        Adgovor: '',
      }
      
      if (assortments.length > 0) {
        rows.push(
          ...assortments.map(({label, answer}) => {
            return {...exportRow, Asortiman: label, Adgovor: answer,};
          })
        );
      } else {
        rows.push(exportRow);
      }
    });

    return rows;
  };

  const fetchSubmissions = async isDateQuery => {
    
    const startDate = moment().subtract(30, 'd').set({ hour : 0, minute : 0, second : 0, millisecond : 0 }).toDate()
    const endDate = moment().set({ hour : 23, minute: 59, second : 59 , millisecond : 0 }).toDate()

    let subs;
    if (userRole === 'admin') {
      subs = db.collection('submissions').orderBy('created', 'desc');

      if (isDateQuery) {
        subs = subs
          .where('created', '>=', startDate)
          .where('created', '<=', endDate);
      }

      subs = await (await subs.get()).docs.map(sub => ({
        id: sub.id,
        ...sub.data()
      }));
    }

    if (userRole === 'partner') {
      subs = db
        .collection('submissions')
        .where('partnerInfo.id', '==', userId)
        .orderBy('created', 'desc');
      if (isDateQuery) {
        subs = subs
          .where('created', '>=', startDate)
          .where('created', '<=', endDate);
      }
      subs = await (await subs.get()).docs.map(sub => ({
        id: sub.id,
        ...sub.data()
      }));
    }

    const isSpecialPartner = Boolean(['papillon', 'pikrijeka'].find(usr => usr === username))

    if (userRole === 'partner' && isSpecialPartner) {
      // case of Papillon partner
      if (username === 'papillon') {
        subs = db
          .collection('submissions')
          .where('workerInfo.isPapillon', '==', true)
          .orderBy('created', 'desc');
      }

      // case Pikrijeka partner
      if (username === 'pikrijeka') {
        subs = db
          .collection('submissions')
          .where('partnerInfo.isPikrijeka', '==', true)
          .orderBy('created', 'desc');
      }

      if (isDateQuery) {
        subs = subs
          .where('created', '>=', startDate)
          .where('created', '<=', endDate);
      }

      subs = await (await subs.get()).docs.map(sub => ({
        id: sub.id,
        ...sub.data()
      }));
    }

    if (userRole === 'worker') {
      subs = db
        .collection('submissions')
        .where('workerInfo.id', '==', userId)
        .orderBy('created', 'desc');

      if (isDateQuery) {
        subs = subs
          .where('created', '>=', startDate)
          .where('created', '<=', endDate);
      }
      subs = await (await subs.get()).docs.map(sub => ({
        id: sub.id,
        ...sub.data()
      }));
    }

    return subs;
  };

  const fetchSubmissionsWithFilters = async () => {
    const keys = Object.keys(filters);
    const values = Object.values(filters);
    let query;
    if (userRole === 'admin') {
      query = db.collection('submissions');
    }

    // case: Papillon partner
    else if (userRole === 'partner' && username === 'papillon') {
      query = db
        .collection('submissions')
        .where('workerInfo.isPapillon', '==', true)
    }

    // case: Pikrijeka partner
    else if (userRole === 'partner' && username === 'pikrijeka') {
      query = db
        .collection('submissions')
        .where('partnerInfo.isPikrijeka', '==', true)
    }

    else if (userRole === 'partner') {
      query = db
        .collection('submissions')
        .where('partnerInfo.id', '==', userId);
    }

    else if (userRole === 'worker') {
      query = db.collection('submissions').where('workerInfo.id', '==', userId);
    }

    keys.forEach((key, index) => {
      if (values[index] !== null) {
        switch (key) {
          case 'startDate':
            const start = new Date(values[index].setHours(0, 0, 0, 0));
            query = query.where('created', '>=', start);
            break;
          case 'endDate':
            const end = new Date(values[index].setHours(23, 59, 59, 0));
            query = query.where('created', '<=', end);
            break;
          case 'reference':
            query = query.where('reference', '==', values[index]);
            break;
          case 'partner':
            query = query.where('partnerInfo.name', '==', values[index]);
            break;
          case 'worker':
            query = query.where('workerInfo.username', '==', values[index]);
            break;
          case 'storeNumber':
            query = query.where('storeInfo.number', '==', values[index]);
            break;
          case 'storeName':
            query = query.where('storeInfo.name', '==', values[index]);
            break;
          case 'classification':
            query = query.where('storeInfo.classification', '==', values[index]);
            break;
          case 'type':
            query = query.where('storeInfo.type', '==', values[index]);
            break;
          case 'region':
            query = query.where('storeInfo.address.region', '==', values[index]);
            break;
          case 'city':
            query = query.where('storeInfo.address.city', '==', values[index]);
            break;
          case 'street':
            query = query.where('storeInfo.address.street', '==', values[index]);
            break;
          default:
            break;
        }
      }
    });
    return await (
      await query.orderBy('created', 'desc').get()
    ).docs.map(sub => ({ id: sub.id, ...sub.data() }));
  };

  const createSetFromArray = array =>
    [...new Set(array.map(item => item.label))].map(item => ({ label: item }));

  const handleRowClick = async subData => {
    history.push(`/submissions/${subData.reference}`, {
      reference: subData.reference
    });
  };

  const handleApplyFilter = _filters => {
    setSelectedSubmissions([]);
    dispatch({
      type: actionTypes.APPLY_FILTER,
      filters: _filters
    });
  };

  const handleClearFilter = async () => {
    dispatch({
      type: actionTypes.CLEAR_FILTER
    });
    setLoading(true);
    const fetchedSubs = await fetchSubmissions();
    //Set submissions list if we don't have filtered subs

    const newExportData = fetchedSubs.map(sub => {
      // const sub = _sub.data()
      return {
        id: sub.id,
        date: formattedDateWithMoment(sub.created),
        reference: sub.reference,
        partner: sub.partnerInfo.name,
        worker: sub.workerInfo.username,
        storeNumber: sub.storeInfo.number,
        storeName: sub.storeInfo.name,
        city: sub.storeInfo.address.city,
        street: sub.storeInfo.address.street,
        country: sub.storeInfo.country || '',
        comments: sub.comments.length,
        products: sub.products,
        orderNotice: sub.orderNotice,
        assortments: sub.assortments || []
      };
    });
    
    setExportSubmissions(exportSubsUtil(newExportData));
    setExportSubsWithAssortment(exportWithAssortmentFortmetter(newExportData));

    setSubmissions(
      fetchedSubs.map(sub => {
        return {
          id: sub.id,
          date: formattedDateWithMoment(sub.created),
          reference: sub.reference,
          partner: sub.partnerInfo.name,
          worker: sub.workerInfo.username,
          storeNumber: sub.storeInfo.number,
          storeName: sub.storeInfo.name,
          city: sub.storeInfo.address.city,
          street: sub.storeInfo.address.street,
          comments: sub.comments.length,
          classification: sub.storeInfo.classification,
          type: sub.storeInfo.type
        };
      })
    );
    setLoading(false);
  };

  const notAllFiltersNull = () =>
    Object.values(filters || {}).find(value => value !== null);

  useEffect(() => {
    (async () => {
      if (notAllFiltersNull()) {
        setLoading(true);
        const fetchedSubs = await fetchSubmissionsWithFilters();
        const newFilteredData = fetchedSubs.map(sub => {
          // const sub = _sub.data()
          return {
            id: sub.id,
            date: formattedDateWithMoment(sub.created),
            reference: sub.reference,
            partner: sub.partnerInfo.name,
            worker: sub.workerInfo.username,
            storeNumber: sub.storeInfo.number,
            storeName: sub.storeInfo.name,
            city: sub.storeInfo.address.city,
            street: sub.storeInfo.address.street,
            comments: sub.comments.length,
            classification: sub.storeInfo.classification,
            type: sub.storeInfo.type
          };
        });
        const newExportData = fetchedSubs.map(sub => {
          // const sub = _sub.data()
          return {
            id: sub.id,
            date: formattedDateWithMoment(sub.created),
            reference: sub.reference,
            partner: sub.partnerInfo.name,
            worker: sub.workerInfo.username,
            storeNumber: sub.storeInfo.number,
            storeName: sub.storeInfo.name,
            city: sub.storeInfo.address.city,
            street: sub.storeInfo.address.street,
            country: sub.storeInfo.country || '',
            comments: sub.comments.length,
            products: sub.products,
            orderNotice: sub.orderNotice,
            assortments: sub.assortments || []
          };
        });

        dispatch({
          type: actionTypes.SET_FILTERED_DATA,
          filteredData: newFilteredData
        });
        
        setExportSubmissions(exportSubsUtil(newExportData));
        setExportSubsWithAssortment(exportWithAssortmentFortmetter(newExportData));

        setSubmissions(newFilteredData);
        setLoading(false);
      }
    })();
  }, [filters, refreshFilterSubs]);

  useEffect(() => {

    (async () => {
      setLoading(true);
      const fetchedSubs = await fetchSubmissions(isShortQuery);
      //Set submissions list if we don't have filtered subs
      if (filteredSubmissions.length === 0) {
        setSubmissions(
          fetchedSubs.map(sub => {
            return {
              id: sub.id,
              date: formattedDateWithMoment(sub.created),
              reference: sub.reference,
              partner: sub.partnerInfo.name,
              worker: sub.workerInfo.username,
              storeNumber: sub.storeInfo.number,
              storeName: sub.storeInfo.name,
              city: sub.storeInfo.address.city,
              street: sub.storeInfo.address.street,
              comments: sub.comments.length,
              classification: sub.storeInfo.classification,
              type: sub.storeInfo.type
            };
          })
        );

        setLoading(false);

        const dataToExport = fetchedSubs.map(sub => {
          return {
            id: sub.id,
            date: formattedDateWithMoment(sub.created),
            reference: sub.reference,
            partner: sub.partnerInfo.name,
            worker: sub.workerInfo.username,
            storeNumber: sub.storeInfo.number,
            storeName: sub.storeInfo.name,
            city: sub.storeInfo.address.city,
            street: sub.storeInfo.address.street,
            country: sub.storeInfo.country || '',
            comments: sub.comments.length,
            products: sub.products,
            orderNotice: sub.orderNotice,
            assortments: sub.assortments || []
          };
        })

        setExportSubmissions(exportSubsUtil(dataToExport));
        setExportSubsWithAssortment(exportWithAssortmentFortmetter(dataToExport));
      }

      if (!areFiltersEstablished) {
        const _references = [];
        const _partners = [];
        const _workers = [];
        const _storeNumbers = [];
        const _storeNames = [];
        const _classifications = [];
        const _types = [];
        const _regions = [];
        const _cities = [];
        const _streets = [];
        //Create filters laels
        for (let sub of fetchedSubs) {
          _references.push({ label: sub.reference });
          _partners.push({ label: sub.partnerInfo.name });
          _workers.push({ label: sub.workerInfo.username });
          _storeNumbers.push({ label: sub.storeInfo.number });
          _storeNames.push({ label: sub.storeInfo?.name });
          _classifications.push({ label: sub.storeInfo.classification });
          _types.push({ label: sub.storeInfo.type });
          _regions.push({ label: sub.storeInfo?.address.region });
          _cities.push({ label: sub.storeInfo?.address.city });
          _streets.push({ label: sub.storeInfo?.address.street });
        }
        //set filters options
        setReferences(createSetFromArray(_references));
        setPartners(createSetFromArray(_partners));
        setWorkers(createSetFromArray(_workers));
        setStoreNumbers(createSetFromArray(_storeNumbers));
        setStoreNames(createSetFromArray(_storeNames));
        setClassifications(createSetFromArray(_classifications));
        setTypes(createSetFromArray(_types));
        setRegions(createSetFromArray(_regions));
        setCities(createSetFromArray(_cities));
        setStreets(createSetFromArray(_streets));
        setAreFiltersEstablished(true); //to avoid re-establishing filters with filtered subs
      }
    })();
  }, [isShortQuery, refreshSubs]);

  const updateSubmissions = async () => {
    setSelectedSubmissions([]);
    if (notAllFiltersNull()) {
      setRefreshFilterSubs(Math.random() * 99999);
    } else {
      setRefreshSubs(Math.random() * 99999);
    }
  };

  const deleteSubmissionHandler = async () => {
    const selectedSubmissionsIds = [...selectedSubmissions];
    let batch = db.batch();
    selectedSubmissionsIds.forEach(docId => {
      const docRef = db.collection('submissions').doc(docId);
      batch.delete(docRef);
    });
    // const resBatch = await batch.commit();
    await batch.commit();
    setDeleteDialogOpen(false);
    await updateSubmissions();
    enqueueSnackbar(t('notifications.submissionsDeleted'), {variant: 'success'})
  };

  return (
    <div className={classes.root}>
      <Grid
        className={classes.grid}
        container
      >
        <Grid
          className={classes.content}
          item
          lg={12}
          xs={12}
        >
          <div className={classes.content}>
            <div className={classes.contentBody}>
              <div className={classes.filters}>
                <FilterSection
                  cities={cities}
                  classifications={classifications}
                  handleApplyFilter={handleApplyFilter}
                  handleClearFilter={handleClearFilter}
                  partners={partners}
                  references={references}
                  regions={regions}
                  storeNames={storeNames}
                  storeNumbers={storeNumbers}
                  streets={streets}
                  types={types}
                  userInfo={{ userRole, username }}
                  workers={workers}
                />
              </div>
            </div>
            <ExportCard className={classes.exportContainer}>
              {hasSelectedItems && userRole === 'admin' && (
                <BasicFab
                  handleClick={() => setDeleteDialogOpen(true)}
                  label={t('button.deleteSubmissions')}
                  remove
                />
              )}
              <ExportCSVButton
                csvData={
                  filteredSubmissions.length !== 0
                    ? filteredSubmissions
                    : submissions
                }
                fileName={'submissions'}
                name={t('button.export')}
                selectedItems={selectedSubmissions}
                skipCol={['id']}
              />              
              <ExportCSVButton
                csvData={exportSubsWithAssortment}
                fileName={'submissions-with-assortments'}
                name={t('button.exportWithAssortments')}
                selectedItems={selectedSubmissions}
                skipCol={['id', 'comments']}
              />
              <ExportCSVButton
                csvData={exportSubmissions}
                fileName={'submissions-with-products'}
                name={t('button.exportWithProduct')}
                selectedItems={selectedSubmissions}
                skipCol={['id', 'comments']}
              />
            </ExportCard>
            {isShortQuery && (
              <Card
                className={classes.exportContainer}
                style={{
                  justifyContent: 'center',
                  alignItems: 'center'
                }}
              >
                <Typography variant="h5">{t('filter.msgDays')}</Typography>
                <Button
                  color="secondary"
                  onClick={() => {
                    setLoading(true);
                    setIsShortQuery(false);
                  }}
                  style={{ marginLeft: '16px' }}
                  variant="outlined"
                >
                  {t('button.clearFilter')}
                </Button>
              </Card>
            )}
            <div className={classes.tableContainer}>
              <SubmissionsTable
                data={filteredSubmissions.length !== 0
                  ? filteredSubmissions
                  : submissions
                }
                headers={tableHeaders}
                history={history}
                isSubmissionsList
                loading={loading}
                onRowClick={handleRowClick}
                selectedItems={selectedSubmissions}
                setSelectedItems={setSelectedSubmissions}
                skipCol={['classification', 'type']}
                styles={classes.table}
                withLink
                withPagination
              />
            </div>
          </div>
        </Grid>
      </Grid>
      <BasicDialog
        count={selectedSubmissions.length}
        handleClose={() => setDeleteDialogOpen(false)}
        handleConfirm={() => deleteSubmissionHandler()}
        open={deleteDialogOpen}
        title={t('dialog.deleteSubmissions')}
      />
    </div>
  );
};

SubmissionsList.propTypes = {
  history: PropTypes.object
};

export default withRouter(SubmissionsList);
